import React, { useEffect, useState } from 'react';
import { FILE_DOWNLOAD, GUTTOR_SPACE_SMALL } from '../../../shared/constants/commonConstants';
import { Row, Col, DatePicker, Tooltip, Form } from 'antd';
import moment from 'moment';
import { ReactComponent as DownloadIcon } from '../../../assets/images/svg/i_download.svg';
import { ReactComponent as AddIcon } from '../../../assets/images/svg/i_add.svg';

const DragableUploadListItem = (props: any): any => {
  const { originNode, file, onFileAddition } = props;
  const [fileD, setFIleD] = useState(null as any);
  const [isAdded, setIsAdded] = useState(false);
  const [form] = Form.useForm();
  useEffect((): void => {
    setFIleD(file);
  }, [file]);
  const fileDownloadURL = process.env.REACT_APP_BASE_URL + FILE_DOWNLOAD;

  const ref = React.useRef() as any;

  const errorNode = (
    <div className="errorNode" style={{ color: 'red' }}>{originNode.props.children}</div>
  );

  const onDownload = (uid: any): any => {

    const downloadUrl = `${fileDownloadURL}/${uid}`;
    const downloadFrame = document.createElement('iframe');
    downloadFrame.setAttribute('src', downloadUrl);
    downloadFrame.setAttribute('class', 'screenReaderText');
    document.body.appendChild(downloadFrame);
  };

  const onStartDateChange = (e: any): void => {
    if (e) {

      setFIleD({
        ...fileD,
        item: {
          ...fileD?.item,
          startDate: moment(new Date(e?._d)),
        },
      });
    } else {
      setIsAdded(false);
    }
  };

  const onEndDateChange = (e: any): void => {
    if (e) {
      setFIleD({
        ...fileD,
        item: {
          ...fileD?.item,
          endDate: moment(new Date(e?._d)),
        },
      });
    } else {
      setIsAdded(false);
    }
  };

  const onAddClick = async (fileId: any): Promise<void> => {
    const validations: any = await form.validateFields();
    if (validations && validations.errorFields && validations.errorFields.length) {
      setIsAdded(false);
      return;
    } else {
      onFileAddition(fileId);
      setIsAdded(true);
    }
  };

  const successNode = (
    <Form form={form}>
      <Row className="success-node"
        style={{ borderColor: isAdded ? 'var(--cr_success)' : 'var(--cr_error)' }} gutter={GUTTOR_SPACE_SMALL}>
        <Col md={5} className="text-elipsis fsize_sm">{originNode.props.children}</Col>
        <Col md={5}>
          <span className="fsize_sm pending bold">pending</span>
        </Col>
        <span onClick={(): any => onAddClick(fileD)} style={{ position: 'absolute', right: '12px', top: '3px', cursor: 'pointer' }}>
          <AddIcon className="fill-primary v-align-middle" />
        </span>
        <Col md={6}>
          <Form.Item name="startDate" rules={[{ required: true }]}>
            <DatePicker className="bottom-brdr-picker"
              placeholder="Start date" value={fileD?.item?.startDate} onChange={onStartDateChange} />
          </Form.Item>
        </Col>
        <Col md={6}>
          <Form.Item name="endDate" rules={[{ required: true }]}>
            <DatePicker className="bottom-brdr-picker"
              placeholder="End date" value={fileD?.item?.endDate} onChange={onEndDateChange} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );

  const originalNode = (

    <Row className="original-node" gutter={GUTTOR_SPACE_SMALL}>
      <Tooltip title={fileD?.item?.docName}>
        <Col md={5} className="text-elipsis fsize_sm">{originNode.props.children}</Col>
      </Tooltip>
      <span onClick={(): any => onDownload(fileD.uid)} style={{ position: 'absolute', right: '12px', top: '3px', cursor: 'pointer' }}>
        <DownloadIcon className="fill-gray mouse-pointer v-align-middle" />
      </span>
      <Col md={5}>
        {fileD?.item?.isApproved ? <span className="approved fsize_sm bold">approved</span> :
          <span className="fsize_sm pending bold">pending</span>}
      </Col>
      <Col md={6}><DatePicker className="bottom-brdr-picker"
        disabled={true} defaultValue={moment(new Date(fileD?.item?.startDate))} /></Col>
      <Col md={6}><DatePicker className="bottom-brdr-picker"
        disabled={true} defaultValue={moment(new Date(fileD?.item?.endDate))} /></Col>
    </Row>

  );

  return (
    <div
      ref={ref}
      className={`ant-upload-draggable-list-item`}
      style={{ cursor: 'move' }}
    >
      {fileD &&
        <>
          {fileD.status === 'uploaded' ? originalNode : fileD.status === 'done' ? errorNode : successNode}
        </>
      }
    </div>
  );
};

export default DragableUploadListItem;
